export interface CancelReserveSeatDto {
  whileJoining: boolean;
}
